import React, { createContext, useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

function clearLocalSessionState(setToken, setUser) {
  localStorage.removeItem('accessToken');
  setToken(null);
  setUser(null);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('accessToken') || null);
  const [isLoading, setIsLoading] = useState(true);

  const logout = useCallback(() => {
    clearLocalSessionState(setToken, setUser);
    if (API_BASE) {
      fetch(`${API_BASE}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      }).catch(() => {});
    }
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem('accessToken');
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        const expMs = decoded?.exp ? decoded.exp * 1000 : 0;
        if (expMs && Date.now() >= expMs) {
          clearLocalSessionState(setToken, setUser);
        } else {
          setUser({
            id: decoded.id,
            name: decoded.name,
            email: decoded.email,
            isAdmin: decoded.isAdmin,
            role: decoded.role || (decoded.isAdmin ? 'admin' : 'customer'),
          });
          setToken(storedToken);
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Token inválido:', error);
        }
        clearLocalSessionState(setToken, setUser);
      }
    } else {
      clearLocalSessionState(setToken, setUser);
    }
    setIsLoading(false);
  }, []);

  const login = (newToken) => {
    localStorage.setItem('accessToken', newToken);
    setToken(newToken);
    const decoded = jwtDecode(newToken);
    setUser({
      id: decoded.id,
      name: decoded.name,
      email: decoded.email,
      isAdmin: decoded.isAdmin,
      role: decoded.role || (decoded.isAdmin ? 'admin' : 'customer'),
    });
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
